import React, { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useUserData } from 'utils/user';
import FirstTimeLogin from '../sections/FirstTimeLogin';
import profileApi from '../apiFrontend/profileApi';
import { useDispatch } from 'react-redux';

const SystemProfile: React.FC = ({ children }) => {
  const { accessToken } = useUserData();
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();

  const { data: profileData, refetch: profileRefetch } = profileApi.useGetProfileQuery(null, {
    skip: !isAuthenticated || !accessToken,
  });

  useEffect(() => {
    if (isAuthenticated && accessToken) {
      profileRefetch();
    }

    return () => {
      dispatch(profileApi.util.invalidateTags(['all-profile']));
    };
  }, [isAuthenticated, accessToken]);

  return (
    <>
      {children}
      {profileData?.noProfileData && isAuthenticated && <FirstTimeLogin />}
    </>
  );
};

export default SystemProfile;
